export default __webpack_public_path__ + "static/8-6a421a8422a9ec7d3ef0886ce64267c1.jpg";